<div class="container-sale" id="container-sale">
	<div id="title-page" class="card mb-3 title-page">
		<div class="row title-total">
			<div class="col-sm">
				<h4 style="font-weight: 900;margin:auto">Factura de venta</h4>
			</div>
			<span class="col-sm totals-span" style="color: gray;">
				Total de 
				<b *ngIf="options.selected=='quotation'"> {{'Cotización'}}</b>
				<b *ngIf="options.selected=='saleOrder'"> {{'Pedido'}}</b>
				<b *ngIf="options.selected!='quotation' && options.selected!='saleOrder'"> {{'Factura'}}</b>
				<span id="total-to-pay"><ng-container *ngTemplateOutlet="currency;"></ng-container>
					{{totals.toPay.sum | number:'1.0-4'}}</span>
			</span>
			<span class="col-sm totals-span" style="color: goldenrod;" [hidden]="options.selected=='quotation' || options.selected=='saleOrder' || options.selected=='advancePayment'">
				Total de <b> Pago</b>
				<span id="total-paid"><ng-container *ngTemplateOutlet="currency;"></ng-container>
					{{ totals.paid | number:'1.0-4'}}</span>
			</span>
			<span class="col-sm totals-span" style="color: goldenrod;" [hidden]="options.selected!='advancePayment'">
				Total de <b> Anticipo</b>
				<span id="total-paid"><ng-container *ngTemplateOutlet="currency;"></ng-container>
					{{ totals.paid | number:'1.0-4'}}</span>
			</span>
			<!-- <span class="col-sm totals-span" style="color: grey;" [hidden]="(options.selected=='quotation' || options.selected=='saleOrder') || !isAffiliate">
				<b>Puntos </b>
				<span id="total-paid" style="color: grey;"> {{ affiliatePoints | number:'1.0'}}</span>
			</span> -->
			<span class="col-sm totals-span" 
			[class.text-success]="(totals.creditAvailable-totals.toPay.productList) > 0" 
			[class.text-danger]="(totals.creditAvailable-totals.toPay.productList) <= 0"
			[hidden]="options.selected!='saleOrder'">
				Total de <b> Crédito</b>
				<span id="total-paid"
				[class.text-success]="(totals.creditAvailable-totals.toPay.productList) > 0" 
			[class.text-danger]="(totals.creditAvailable-totals.toPay.productList) <= 0"
			><ng-container *ngTemplateOutlet="currency;"></ng-container>
					{{ (totals.creditAvailable-totals.toPay.productList) | number:'1.0-4'}}</span>
			</span>
		</div>
	</div>
	<div class="card"
		[class.mb-3]="!(options.exportInvoice && options.electronicInvoice && options.selected=='invoice') && !order">
		<div class="card-header d-flex justify-content-between align-items-center">
			<h3>1. Bodega, cliente y datos de factura </h3>
		</div>
		<div class="card-body">
			<div class="">
				<div class="row">
					<div class="col-sm">
						<div class="input-group input-group-sm mb-2" *ngIf="options.selected=='saleOrder'">
								<span class="input-group-text">Destino: 
									<span *ngIf="lastDestinationWarehouse!=null && destinationsWarehouse.length>0" class="ml-1">
										{{lastDestinationWarehouse.destinationData.name}}
									</span>
									<span *ngIf="lastDestinationWarehouse==null && destinationsWarehouse.length==0" class="ml-1">
										-- SIN ASINGNAR --
									</span>
								</span>
						</div>
						<div id="warehouse-input-container" class="input-group input-group-sm mb-2">
							<label for="warehouse-input" class="input-group-text">Bodega
							</label>
							<button [appCheckPermission]="[5007,5008]" [permissionType]="permissionType.CREATE"
								class="btn btn-primary btn-icon" type="button" data-bs-toggle="tooltip"
								data-bs-custom-class="custom-tooltip" data-bs-title="Crea una nueva bodega"
								data-bs-placement="top"><i class="bx bxs-plus-circle"
									(click)="creatingNewWarehouse = true"></i></button>
							<div class="btn-group" id="options-warehouse" class="options-toggle">
								<button type="button" class="btn btn-primary" data-bs-toggle="dropdown"
									aria-haspopup="true">
									<i class="bx bx-dots-vertical-rounded"></i>
								</button>
								<div class="dropdown-menu">
									<button class="dropdown-item">Crear bodega</button>
									<button class="dropdown-item">Listar bodegas</button>
								</div>
							</div>
							<app-input-autocomplete [allBorderRadius]="false" [inputs]="inputs.warehouse"
								[placeholder]="'Ingresa o crea una bodega'" [filterElements]="filterWarehouses"
								[typeElements]="'warehouse'" (changeMethod)="verifiedInput($event.event,'warehouse')"
								(inputMethod)="handleInput($event.event,'warehouse')"
								(getTitle)="$event.filterElement.title = ($event.filterElement.name) + (placesRecord[$event.filterElement.place]? ' / ' + (placesRecord[$event.filterElement.place]?.name) : '')"
								(changeStatus)="changeStatusInput(
									$event.filterElement,
									$event.filterElement.name + (placesRecord[$event.filterElement.place]? ' / ' + (placesRecord[$event.filterElement.place]?.name) : ''),
									1,'warehouse')"
								[ruleToDisabled]="validateDisableWarehouse"
								></app-input-autocomplete>
						</div>
						<div id="client-input-container" class="input-group input-group-sm mb-2">
							<label for="client-input" class="input-group-text">Cliente <span
									style="color: transparent;">.</span></label>
							<button
								*ngIf="companyIsAdmin"
								class="btn btn-primary btn-icon"
								type="button"
								data-bs-toggle="tooltip"
								data-bs-custom-class="custom-tooltip"
								data-bs-title="Administrar NIT de facturación"
								data-bs-placement="top"
								[disabled]="!inputs.client?.data?.id"
								(click)="openClientOptionsModal()">

								<i class="bx bxs-plus-circle"></i>

							</button>
							<app-input-autocomplete
								[allBorderRadius]="false"
								[inputs]="inputs.client"
								[placeholder]="'Ingresa nombre, NIT o celular'"
								[filterElements]="filterClients"
								[typeElements]="'client'"
								(inputMethod)="handleInput($event.event,'client')"

								(getTitle)="
									$event.filterElement.title =
									getClientDisplayName($event.filterElement)
								"

								(changeStatus)="changeStatusInput(
									$event.filterElement,
									getClientDisplayName($event.filterElement),
									1,
									'client'
								)">
							</app-input-autocomplete>
						</div>
						<div class="input-group input-group-sm mb-2" *ngIf="vendorBillingNits.length > 0">

							<label
								for="vendorBillingNit"
								class="input-group-text">

								NIT Facturación
								<span class="text-danger">*</span>

							</label>

							<select
								id="vendorBillingNit"
								name="vendorBillingNit"
								class="form-select"
								[(ngModel)]="vendorBillingNitId">

								<option
									[ngValue]="null"
									disabled>

									Selecciona un NIT de facturación

								</option>

								<option
									*ngFor="let billing of vendorBillingNits"
									[ngValue]="billing.id">

									{{ billing.billingNit }} - {{ billing.billingName }}

								</option>

							</select>

						</div>
						<div class="row">
							<div class="col-sm">
								<div class="input-group input-group-sm mb-2">
									<label for="inputGroupSelect" class="input-group-text">Fecha</label>
									<input type="date" [(ngModel)]="inputs.date" id="fecha" name="fecha"
										class="form-control">
								</div>
							</div>
							<div class="wrapper col-sm">
								<div class="text" style="padding-right: 1rem; font-weight: bold;">Moneda</div>
								<input id="currency" name="currency" type="checkbox" (change)="dollar=!dollar">
								<label class="button" for="currency">
									<div class="dot"></div>
								</label>
								<div class="dollar-text">Dolar</div>
							</div>
						</div>
						<div class="input-group input-group-sm mb-2 mt-1">
							<label for="description" class="input-group-text">Observaciones</label>
							<textarea class="form-control" name="description"
								placeholder="Ingrese tus observaciones para esta factura de venta, tienes hasta 100 caracteres"
								id="description" [(ngModel)]="inputs.description" cols="30" rows="2"></textarea>
						</div>
						<div class="wrapper col-sm" style="flex-direction: column;" *ngIf="orders.length > 0">
							<div class="text" style="padding-right: 1rem; font-weight: bold;">¿Desea seleccionar una
								orden de venta?</div>
							<div class="order-div">
								<input id="order" name="order" type="checkbox" (change)="order=!order">
								<label class="button" for="order">
									<div class="dot"></div>
								</label>
								<div [class.checked-text]="order">{{ order ? 'Sí' : 'No'}}</div>
							</div>
							<span *ngIf="order" id="info-order"><i class="bx bxs-info-circle"></i>Se agregó el apartado
								<span class="noselect" (click)="sendToDiv('order-div')">{{ options.exportInvoice &&
									options.electronicInvoice &&
									options.selected=='invoice' ? '1.2' : '1.1'}} Orden de Venta
								</span>
							</span>
						</div>
					</div>
					<div class="col-sm">
						<div class="accordion" id="accordionExample">
							<div class="accordion-item" *ngIf="checkAdministration && loadingConfig">
								<div class="input-radio" id="div-administrative"
									[class.div-checked]="options.selected=='administrative'"
									(click)="options.selected='administrative'">
									<input id="inputQuotation" class="radioData" [(ngModel)]="options.selected"
										value="administrative" name="options" type="radio">
									<span class="text-radio">Seleccione esta opción si emitió una factura. (Administrativa)</span>
								</div>
								<div class="showWithInput" [class.showInvoice]="options.selected=='administrative'">
									<div class="row">
										<div class="wrapper col-sm wrapper-custom">
											<input id="type-invoice" name="type-invoice" type="checkbox"
												[(ngModel)]="options.electronicInvoice">
											<label class="button2" for="type-invoice">
												<div class="dot2"
													(click)="options.electronicInvoice=!options.electronicInvoice">
												</div>
											</label>
											<div class="type-text">Fact. Electronica</div>
										</div>
										<div [ngClass]="{'wrapper wrapper-custom': options.electronicInvoice==true}"
											class="col-sm">
											<ng-container *ngIf="options.electronicInvoice==false">
												<label for="serie" class="label-div-invoice">No. Serie</label>
												<div class="input-group input-group-sm mb-2">
													<input type="number" class="form-control" name="serie" id="serie"
														placeholder="Ingrese número de serie"
														[(ngModel)]="options.invoice.serie">
												</div>
											</ng-container>
											<ng-container *ngIf="options.electronicInvoice==true">
												<input id="export-invoice" name="export-invoice" type="checkbox"
													[(ngModel)]="options.exportInvoice">
												<label class="button2" for="export-invoice">
													<div class="dot2"
														(click)="options.exportInvoice=!options.exportInvoice"></div>
												</label>
												<div class="export-text">Fact. Exportación</div>
											</ng-container>
										</div>
										<div [ngClass]="{'wrapper wrapper-custom': options.electronicInvoice==true}"
											class="col-sm">
											<ng-container *ngIf="options.electronicInvoice==false">
												<label for="factura" class="label-div-invoice">No. Factura</label>
												<div class="input-group input-group-sm mb-2">
													<input type="number" class="form-control" name="factura"
														id="factura" placeholder="Ingrese número de factura"
														[(ngModel)]="options.invoice.number">
												</div>
											</ng-container>
											<ng-container *ngIf="options.electronicInvoice==true">
												<input id="send-email" name="send-email" type="checkbox"
													[(ngModel)]="options.sendEmail">
												<label class="button2" for="send-email">
													<div class="dot2" (click)="options.sendEmail=!options.sendEmail">
													</div>
												</label>
												<div class="email-text">Enviar correo</div>
											</ng-container>
										</div>
									</div>
									<div class="row">
										<div class="form-group col-sm">
											<label for="producto">Tipo de factura</label>
											<div class="input-group input-group-sm mb-2">
												<select class="form-select"
													[disabled]="!inputs.warehouse.data?.id || options.invoice?.types.length == 0 "
													name="inputGroupSelectFactura" [(ngModel)]="options.invoice.type"
													id="inputGroupSelectFactura">
													<option
														*ngIf="options.invoice?.types.length == 0 && inputs.warehouse.data?.id"
														[ngValue]="undefined">
														No tiene asignados
													</option>
													<option *ngIf="!inputs.warehouse.data?.id" [ngValue]="undefined">
														Elige una bodega primero
													</option>
													<option *ngFor="let typedoc of options.invoice.types"
														value="{{typedoc.typeDoc}}">
														{{typedoc.describeDoc}}</option>
												</select>
											</div>
										</div>
										<div class="form-group col-sm"
											*ngIf="options.sendEmail && options.electronicInvoice">
											<label for="email">Email</label>
											<div class="input-group input-group-sm mb-2">
												<input type="text" class="form-control" name="email" id="email"
													placeholder="cliente@email.com" [(ngModel)]="options.invoice.email">
											</div>
										</div>
										<span *ngIf="options.exportInvoice && options.electronicInvoice"
											id="info-export"><i class="bx bxs-info-circle"></i>Se agregó el apartado
											<span class="noselect" (click)="sendToDiv('complement')">1.1 Complemento de
												exportación</span></span>
									</div>
								</div>
							</div>
							<div class="accordion-item" *ngIf="!checkAdministration && loadingConfig">
								<div class="input-radio" [class.div-checked]="options.selected=='invoice'" id="invoice"
									(click)="options.selected='invoice'">
									<input id="inputInvoice" [(ngModel)]="options.selected" class="radioData"
										value="invoice" name="options" type="radio" checked>
									<span class="text-radio">Seleccione esta opción si emitió una factura</span>
								</div>
								<div class="showWithInput" [class.showInvoice]="options.selected=='invoice'">
									<div class="row">
										<div class="wrapper col-sm wrapper-custom">
											<input id="type-invoice" name="type-invoice" type="checkbox"
												[(ngModel)]="options.electronicInvoice">
											<label class="button2" for="type-invoice">
												<div class="dot2"
													(click)="options.electronicInvoice=!options.electronicInvoice">
												</div>
											</label>
											<div class="type-text">Fact. Electronica</div>
										</div>
										<div [ngClass]="{'wrapper wrapper-custom': options.electronicInvoice==true}"
											class="col-sm">
											<ng-container *ngIf="options.electronicInvoice==false">
												<label for="serie" class="label-div-invoice">No. Serie</label>
												<div class="input-group input-group-sm mb-2">
													<input type="number" class="form-control" name="serie" id="serie"
														placeholder="Ingrese número de serie"
														[(ngModel)]="options.invoice.serie">
												</div>
											</ng-container>
											<ng-container *ngIf="options.electronicInvoice==true">
												<input id="export-invoice" name="export-invoice" type="checkbox"
													[(ngModel)]="options.exportInvoice">
												<label class="button2" for="export-invoice">
													<div class="dot2"
														(click)="options.exportInvoice=!options.exportInvoice"></div>
												</label>
												<div class="export-text">Fact. Exportación</div>
											</ng-container>
										</div>
										<div [ngClass]="{'wrapper wrapper-custom': options.electronicInvoice==true}"
											class="col-sm">
											<ng-container *ngIf="options.electronicInvoice==false">
												<label for="factura" class="label-div-invoice">No. Factura</label>
												<div class="input-group input-group-sm mb-2">
													<input type="number" class="form-control" name="factura"
														id="factura" placeholder="Ingrese número de factura"
														[(ngModel)]="options.invoice.number">
												</div>
											</ng-container>
											<ng-container *ngIf="options.electronicInvoice==true">
												<input id="send-email" name="send-email" type="checkbox"
													[(ngModel)]="options.sendEmail">
												<label class="button2" for="send-email">
													<div class="dot2" (click)="options.sendEmail=!options.sendEmail">
													</div>
												</label>
												<div class="email-text">Enviar correo</div>
											</ng-container>
										</div>
									</div>
									<div class="row">
										<div class="form-group col-sm">
											<label for="producto">Tipo de factura</label>
											<div class="input-group input-group-sm mb-2">
												<select class="form-select"
													[disabled]="!inputs.warehouse.data?.id || options.invoice?.types.length == 0 "
													name="inputGroupSelectFactura" [(ngModel)]="options.invoice.type"
													id="inputGroupSelectFactura">
													<option
														*ngIf="options.invoice?.types.length == 0 && inputs.warehouse.data?.id"
														[ngValue]="undefined">
														No tiene asignados
													</option>
													<option *ngIf="!inputs.warehouse.data?.id" [ngValue]="undefined">
														Elige una bodega primero
													</option>
													<option *ngFor="let typedoc of options.invoice.types"
														value="{{typedoc.typeDoc}}">
														{{typedoc.describeDoc}}</option>
												</select>
											</div>
										</div>
										<div class="form-group col-sm"
											*ngIf="options.sendEmail && options.electronicInvoice">
											<label for="email">Email</label>
											<div class="input-group input-group-sm mb-2">
												<input type="text" class="form-control" name="email" id="email"
													placeholder="cliente@email.com" [(ngModel)]="options.invoice.email">
											</div>
										</div>
										<span *ngIf="options.exportInvoice && options.electronicInvoice"
											id="info-export"><i class="bx bxs-info-circle"></i>Se agregó el apartado
											<span class="noselect" (click)="sendToDiv('complement')">1.1 Complemento de
												exportación</span></span>
									</div>
								</div>
							</div>
							<div class="accordion-item" *ngIf="!checkAdministration">
								<div class="input-radio" id="div-receipt"
									[class.div-checked]="options.selected=='receipt'"
									(click)="options.selected='receipt'">
									<input id="inputReceipt" class="radioData" [(ngModel)]="options.selected"
										value="receipt" name="options" type="radio">
									<span class="text-radio">Seleccione esta opción si emitió un recibo o un
										documento
										de pago</span>
								</div>
								
								<!--
								<div class="showWithInput" [class.showInvoice]="options.selected=='receipt'">
									<div class="row">
										<div class="form-group col-sm">
											<label for="doc">No. Documento</label>
											<div class="input-group input-group-sm mb-2">
												<input type="text" class="form-control" name="doc" id="doc"
													placeholder="Ingrese número de documento"
													[(ngModel)]="options.doc.number">
											</div>
										</div>
									</div>
								</div>
								-->
							</div>
							<div class="accordion-item">
								<div class="input-radio" id="div-quotation"
									[class.div-checked]="options.selected=='quotation'"
									(click)="options.selected='quotation'">
									<input id="inputQuotation" class="radioData" [(ngModel)]="options.selected"
										value="quotation" name="options" type="radio">
									<span class="text-radio">Seleccione esta opción si emitió una cotizacion.</span>
								</div>
							</div>
							<div class="accordion-item">
								<div class="input-radio" id="div-saleOrder"
									[class.div-checked]="options.selected=='saleOrder'"
									(click)="options.selected='saleOrder'">
									<input id="saleOrder" class="radioData" [(ngModel)]="options.selected"
										value="saleOrder" name="options" type="radio">
									<span class="text-radio">Realizar Pedido.</span>
								</div>
							</div>
							<div class="accordion-item">
								<div class="input-radio" id="div-advancePayment"
									[class.div-checked]="options.selected=='advancePayment'"
									(click)="options.selected='advancePayment'">
									<input id="advancePayment" class="radioData" [(ngModel)]="options.selected"
										value="advancePayment" name="options" type="radio">
									<span class="text-radio">Anticipo.</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="card-link" *ngIf="options.exportInvoice && options.electronicInvoice && options.selected=='invoice'">
		<div class="container-link" [class.middle-link]="order">
			<div class="link-div"></div>
			<div class="link-div" *ngIf="order"></div>
		</div>
		<div class="card mb-3" id="complement">
			<div id="card-header-products" class="card-header d-flex justify-content-between align-items-center">
				<h3>1.1 Complemento de exportación </h3>
			</div>
			<div class="card-body">
				<h5>Datos del consignatario</h5>
				<div class="row">
					<div class="col-sm form-group">
						<label for="">Nombre
							<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">
								*</span></label>
						<input type="text" [(ngModel)]="dataExport.consignatario" class="form-control"
							placeholder="Nombre consignatario">
					</div>
					<div class="col-sm form-group">
						<label for="">Direccion
							<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">
								*</span></label>
						<input type="text" [(ngModel)]="dataExport.direccionConsignatario" class="form-control"
							placeholder="Direccion consignatario">
					</div>
					<div class="col-sm form-group">
						<label for="incoterm">Incoterm <span style="color: red;" data-tooltip="Campo requerido"
								data-tooltip-position="top">
								*</span></label>
						<select id="incoterm" class="form-select" [(ngModel)]="dataExport.incoterm">
							<option value="CFR">CFR - Costo y flete</option>
							<option value="CIF">CIF - Costo, seguro y flete</option>
							<option value="CIP">CIP - Flete y seguro pagado hasta</option>
							<option value="CPT">CPT - Flete pagado hasta</option>
							<option value="DAP">DAP - Entrega en su lugar</option>
							<option value="DAT">DAT - Entrega en terminal</option>
							<option value="DDP">DDP - Entregado en destino con derechos pagados</option>
							<option value="EWX">EWX - En fabrica</option>
							<option value="FAS">FAS - Libre al costado del buque</option>
							<option value="FCA">FCA - Libre transportista</option>
							<option value="FOB">FOB - Libre a bordo</option>
							<option value="ZZZ">ZZZ - Otros</option>
						</select>
					</div>
					<div class="col-sm form-group">
						<label for="">Código</label>
						<input type="text" [(ngModel)]="dataExport.codigoConsignatario" class="form-control"
							placeholder="Código consignatario">
					</div>
				</div>
				<hr>
				<h5>Datos del comprador</h5>
				<div class="row">
					<div class="col-sm form-group">
						<label for="">Nombre</label>
						<input type="text" [(ngModel)]="dataExport.nombreComprador" class="form-control"
							placeholder="Nombre comprador">
					</div>
					<div class="col-sm form-group">
						<label for="">Direccion</label>
						<input type="text" [(ngModel)]="dataExport.direccionComprador" class="form-control"
							placeholder="Dirección comprador">
					</div>
					<div class="col-sm form-group">
						<label for="">Código</label>
						<input type="text" [(ngModel)]="dataExport.codigoComprador" class="form-control"
							placeholder="Código comprador">
					</div>
					<div class="col-sm form-group">
						<label for="">Otras referencias</label>
						<input type="text" [(ngModel)]="dataExport.otrasReferencias" class="form-control"
							placeholder="Otras referencias">
					</div>
				</div>
				<hr>
				<h5>Datos del exportador</h5>
				<div class="row">
					<div class="col-sm form-group">
						<label for="">Nombre</label>
						<input type="text" [(ngModel)]="dataExport.nombreExportador" class="form-control"
							placeholder="Nombre del exportador">
					</div>
					<div class="col-sm form-group">
						<label for="">Código</label>
						<input type="text" [(ngModel)]="dataExport.codigoExportador" class="form-control"
							placeholder="Código del exportador">
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="card-link" *ngIf="order && orders.length > 0">
		<div class="container-link">
			<div class="link-div"></div>
		</div>
		<div class="card mb-3" id="order-div">
			<div id="card-header-products" class="card-header d-flex justify-content-between align-items-center">
				<h3>{{ options.exportInvoice && options.electronicInvoice && options.selected=='invoice' ? '1.2' :
					'1.1'}} Orden de
					Venta </h3>
			</div>
			<div class="card-body">
				<h5>Seleccionar Órdenes</h5>
				<div class="row">
					<div class="input-group input-group-sm col-sm">
						<label for="filter" class="input-group-text">Filtrar</label>
						<input type="text" name="filter-order" id="filter-order" class="form-control">
					</div>
					<div class="input-group input-group-sm col-sm">
						<label for="provider-order" class="input-group-text">Cliente</label>
						<select name="provider-order" id="provider-order" class="form-select"
							[(ngModel)]="enabledOrders" (change)="clearOrder()">
							<option value="-1" selected>Todos</option>
							<option *ngFor="let vendor of vendors" value="{{vendor.id}}">{{vendor.id}} - {{vendor.name}}
							</option>
						</select>
					</div>
				</div>
				<div class="table-container table-responsive">
					<table class="table table-striped caption-bottom">
						<caption><strong>Nota:</strong> Al seleccionar una orden de compra de la lista, solo podrás
							seleccionar órdenes de venta que pertenezcan al cliente de la orden de venta que
							selecciones primero. Las órdenes de otros clientes en esa misma bodega se bloquearán.
							Puedes editar eso
							eliminando las que ya has agregado</caption>
						<thead>
							<tr>
								<th scope="col">Número</th>
								<th scope="col">Fecha de Creación</th>
								<th scope="col">Fecha de Entrega</th>
								<th scope="col">Cliente</th>
								<th scope="col">Seleccionar</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let order of orders">
								<td>{{order.number}}</td>
								<td>{{formatTimestampToDateString(order.creationDate)}}</td>
								<td>{{formatTimestampToDateString(order.deliveryDate)}}</td>
								<td>{{order.clientData.nit}} - {{order.clientData.name}}</td>
								<td>
									<input type="checkbox"
										[disabled]="order.clientData.id != enabledOrders && enabledOrders != -1"
										name="order{{order.number}}" id="order{{order.number}}"
										[checked]="order.selected" (change)="addOrder($event,order)">
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<hr>
				<h5>Órdenes seleccionadas</h5>
				<h6 *ngIf="ordersSelected.length == 0"> <i class="bx bxs-info-circle"></i> Acá se mostrarán las órdenes
					que selecciones</h6>
				<div *ngIf="ordersSelected.length > 0">
					<ng-container *ngFor="let order of orders">
						<div class="accordion" id="accordion{{order.number}}" *ngIf="order.selected">
							<div class="accordion-item">
								<h2 class="accordion-header">
									<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
										[attr.data-bs-target]="'#flush' + order.number" aria-expanded="false"
										[attr.aria-controls]="'flush' + order.number">
										<div class="data-flex">
											<span>
												Creación:
												<b>
													{{formatTimestampToDateStringShort(order.creationDate)}}
												</b>
											</span>
											<span>
												Entrega:
												<b>{{formatTimestampToDateStringShort(order.deliveryDate)}}
												</b>
											</span>
											<span>
												Cliente:
												<b>
													{{order.clientData.name}}
												</b>
											</span>
											<span *ngIf="order.detail">
												Total: <ng-container *ngTemplateOutlet="currency;"></ng-container>
												<b>
													{{ order.total |
													number:'1.0-4'}}
												</b>
											</span>
										</div>
									</button>
								</h2>
								<div id="flush{{order.number}}" class="accordion-collapse collapse"
									[attr.data-bs-parent]="'accordion' + order.number">
									<div class="accordion-body">
										<div class="table-container table-responsive" *ngIf="order.detail">
											<table class="table table-striped">
												<thead>
													<tr>
														<th scope="col">Producto</th>
														<th scope="col">Cantidad</th>
														<th scope="col">Precio Unidad</th>
														<th scope="col">Total</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let orderDetail of order.detail">
														<td>{{orderDetail.productData.name}}</td>
														<td>
															<div class="input-group input-group-sm">
																<input type="number" name="order-product"
																	id="order-product{{order.id}}"
																	[(ngModel)]="orderDetail.toDeliver"
																	(input)="getTotalOrder(order)" class="form-control">
															</div>
														</td>
														<td>
															<div class="input-group input-group-sm">
																<label for="order-price" class="input-group-text">
																	<ng-container
																		*ngTemplateOutlet="currency"></ng-container>
																</label>
																<input type="number" value="0"
																	[(ngModel)]="orderDetail.price"
																	(input)="getTotalOrder(order)" name="order-price"
																	id="order-price" class="form-control">
															</div>
														</td>
														<td>{{orderDetail.toDeliver * orderDetail.price |
															number:'1.0-4'}}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
	<div class="card mb-3">
		<div id="card-header-products" class="card-header d-flex justify-content-between align-items-center">
			<h3>2. Productos </h3>
			<datalist id="productList">
				<ng-container *ngFor="let product of products">
					<option [value]="product.name">
						{{product.id}} - {{product.name}}</option>
				</ng-container>
			</datalist>
		</div>
		<div class="card-body">
			<div class="row">
				<div id="product-div" class="col-sm table-toggle">
					<h5 id="title-product-h">Agregar Productos</h5>
					<div class="row">
						<div class="col-sm">
							<div class="form-group">
								<label for="producto">Producto/Servicio
									<span tooltip="Consulta precios" class="clickeable text-info"
										(click)="searchingPrice = true" [appCheckPermission]="[2000, 5020]"
										[permissionType]="permissionType.READ">
										<i class="fa fa-list"></i>
									</span>
								</label>
								<div class="input-group input-group-sm">
									<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.product"
										[placeholder]="'Ingresa el código de barras, id o nombre de un producto'"
										[filterElements]="filterProducts" [typeElements]="'product'"
										(changeMethod)="verifiedInput($event.event,'product')"
										(inputMethod)="handleInput($event.event,'product')"
										(getTitle)="$event.filterElement.title = (($event.filterElement.code)?$event.filterElement.code + ' - ':'')+ $event.filterElement.name"
										[ruleToDisabled]="!inputs.warehouse.verified || !inputs.client.verified"
										(changeStatus)="changeStatusInput($event.filterElement,($event.filterElement.code?$event.filterElement.code+' - ':'')+$event.filterElement.name,1,'product')"></app-input-autocomplete>
									<div class="btn-group btn-group-sm"
										*ngIf="inputs.warehouse.verified && inputs.client.verified && searchProduct['series'].total.length > 0">
										<button [ngClass]="searchProduct.series.data?'btn-success':'btn-primary'"
											class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown"
											data-bs-auto-close="true" aria-expanded="true">
											<i [ngClass]="searchProduct.series.data?'barcode-selected':''"
												class="fa fa-barcode"></i>{{searchProduct.series.data?searchProduct.series.data.seriesProduct:''}}
										</button>
										<ul class="dropdown-menu" style="padding: 1em; width: 400px;">
											<div class="input-group">
												<app-input-autocomplete *ngIf="searchProduct['series']"
													[filterElements]="searchProduct['series'].filterElements"
													placeholder="Ingresa una serie" typeElements="series"
													[inputs]="searchProduct['series']"
													(getTitle)="$event.filterElement.title = $event.filterElement.seriesProduct"
													(inputMethod)="filterSeries()"
													(changeStatus)="selectSeries($event.filterElement)"
													[allBorderRadius]="true"></app-input-autocomplete>
											</div>
										</ul>
									</div>
								</div>
								<div *ngIf="!inputs.warehouse.verified || !inputs.client.verified"
									class="form-text text-danger">Ingresa una bodega y
									cliente primero</div>
							</div>
							<ng-container *ngIf="inputs.warehouse.verified && inputs.client.verified">
								<div class="plus-data">
									<div class="input-group input-group-sm first-input-group"
										[class.without-one]="searchProduct.stock < 0">
										<label for="mount" class="input-group-text">Cantidad</label>
										<input type="number" [(ngModel)]="searchProduct.quantity" value="1"
											class="form-control" name="ammount" id="ammount"
											(ngModelChange)="searchProduct.total = searchProduct.quantity * searchProduct.price"
											[disabled]="!inputs.product.verified || searchProduct.series.data">
									</div>
									<div class="input-group input-group-sm rest-input-group"
										[class.without-one]="searchProduct.stock < 0">
										<label for="price" class="input-group-text">Precio</label>
										<div class="exception">
											<input type="number" [(ngModel)]="searchProduct.price" value="0"
												class="form-control" name="price" id="price"
												[disabled]="searchProduct.prices.length > 0"
												(ngModelChange)="searchProduct.total = searchProduct.quantity * searchProduct.price"
												[disabled]="!inputs.product.verified">
											<div class="btn-group btn-group-sm" *ngIf="searchProduct.prices.length > 0">
												<button class="btn btn-primary dropdown-toggle" type="button"
													data-bs-toggle="dropdown" data-bs-auto-close="true"
													aria-expanded="false">
													<i class="fa fa-tags"></i>
												</button>
												<ul class="dropdown-menu">
													<li *ngFor="let optionPrice of searchProduct.prices">
														<a class="dropdown-item"
															(click)="searchProduct.price = optionPrice.price; searchProduct.total = searchProduct.quantity * searchProduct.price;">{{optionPrice.listData.name}}
															- {{optionPrice.price}}</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<div *ngIf="searchProduct.stock >= 0">
										<label 
											class="input-group-text"
											[style.color]="searchProduct.stock === 0 || searchProduct.quantity > searchProduct.stock ? 'red' : 'green'"
											[style.fontWeight]="'bold'"
											[style.borderRadius]="'0'">
											Existencias {{options.selected=="saleOrder"? searchProduct.stockTemp : ""}}
										</label>
									</div>
									<div *ngIf="options.selected=='saleOrder'">
										<label 
											class="input-group-text text-warning"
											[style.fontWeight]="'bold'"
											[style.borderRadius]="'0'">
											Tránsito {{options.selected=="saleOrder"? searchProduct.inTransitTemp : ""}}
										</label>
									</div>
									<div class="input-group input-group-sm rest-input-group"
										[class.without-one]="searchProduct.stock < 0">
										<label for="total" class="input-group-text">Total</label>
										<input type="number" [(ngModel)]="searchProduct.total" class="form-control"
											name="total" id="total" disabled value="0">
									</div>
								</div>
								<!-- || (searchProduct.stock!=-9999 && searchProduct.quantity > (searchProduct.stockTemp + searchProduct.inTransitTemp) && options.selected=='saleOrder') -->
								<button class="btn btn-primary btn-product" type="button"
									[disabled]="(searchProduct.quantity < 0 && options.selected!='quotation' && !allowOverdraft) 
									|| searchProduct.price <= 0 
									|| !inputs.product.verified 
									|| (searchProduct.stock!=-9999 && searchProduct.quantity > searchProduct.stock && !allowOverdraft && options.selected!='quotation' && options.selected!='saleOrder' && options.selected!='advancePayment')" id="add-product"
									(click)="addProduct()">Agregar
									<i class="fa fa-cart-plus"></i>
								</button>
							</ng-container>
						</div>
					</div>
					<div *ngIf="productsList.length>0" id="miDiv" class="table-container table-responsive">
						<table class="table table-striped" id="table-height">
							<thead>
								<tr class="tr-middle">
									<th scope="col">#</th>
									<th scope="col">Imagen</th>
									<th scope="col">Producto</th>
									<th scope="col">Cantidad</th>
									<th scope="col">Precio Unidad</th>
									<th scope="col">Total</th>
									<!-- <th class="td-center" *ngIf="options.selected=='saleOrder'">
										<div class="d-flex form-group flex-column">
											<label class="form-label">
												Apartar
											</label>
												<input
													type="checkbox"
													[(ngModel)]="stateCheckbox"
													(change)="onCheckboxChange($event)"
												/>
										</div>
									</th> -->
									<th class="td-center" *ngIf="options.selected=='saleOrder'">Comentario</th>
									<th scope="col"></th>
								</tr>
							</thead>
							<tbody class="table-group-divider">
								<tr *ngFor="let product of productsList; let i = index" class="tr-middle row-product"
									id="p{{product.code}}">
									<th scope="row">{{i+1}}</th>
									<th>
										<div class="th-center">
											<img src="{{product.data.image?product.data.image:'../../../../../assets/img/nophoto.svg'}}"
												alt="Sin foto" class="no-photo"
												(error)="$event.target.src = '../../../../../assets/img/nophoto.svg'">
										</div>
									</th>
									<td>
										<div class="row">
											<div class="form-group">
												<span class="product-name text-info" *ngIf="!product.nameEditing"
													(click)="product.nameEditing = true">
													{{product.name}}
													<i class="show-hover bx bxs-edit-alt"></i>
												</span>
												<div class="input-group input-group-sm" *ngIf="product.nameEditing">
													<input type="text" [(ngModel)]="product.name" class="form-control">
													<button class="btn btn-primary"
														(click)="product.nameEditing = false"
														style="border-top-right-radius: var(--bs-border-radius); border-bottom-right-radius: var(--bs-border-radius);">
														<i class="bx bxs-save"></i> </button>
												</div>
												<p class="form-text" style="font-size: 0.7em;" *ngIf="product.series">
													Serie: {{product.series.seriesProduct}}</p>
											</div>
										</div>
									</td>
									<td>
										<div class="input-group">
											<input class="form-control" id="m{{product.id}}" type="number"
												[(ngModel)]="product.quantity" [disabled]="product.series"
												(input)="changeValue(product,'ammount')"
												[disabled]="options.selected === 'saleOrder'"
												>
										</div>
									</td>
									<td><input class="form-control" id="pr{{product.id}}" type="number"
											[(ngModel)]="product.price" (input)="changeValue(product,'price')">
									</td>
									<td><ng-container *ngTemplateOutlet="currency;"></ng-container>.
										{{product.total | number:'1.0-4'}}</td>
									<!-- <td *ngIf="options.selected=='saleOrder'">
										<input type="checkbox" [ngModel]="stateCheckbox" [disabled]="true"/>
									</td> -->
									<td *ngIf="options.selected=='saleOrder'">
										<textarea class="form-control" name="commentdetail"
											placeholder="Comentario"
											id="commentdetail" [(ngModel)]="product.comment" cols="6" rows="1" [maxlength]="15" (resize)="false"></textarea>
									</td>
									<td>
										<div class="flex-td" *ngIf="product.data.exemptTextId!=0">
											<label for="exempt{{product.id}}">¿Exento?</label>
											<input type="checkbox" id="exempt{{product.id}}" name="exempt{{product.id}}"
												[(ngModel)]="product.canBeExempt">
										</div>
										<span class="clickeable text-danger" (click)="deleteProduct(product.id)">
											<i class="fa fa-trash"></i>
										</span>
									</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="5">Total</td>
									<td *ngIf="options.selected=='saleOrder'"></td>
									<td>
										<ng-container *ngTemplateOutlet="currency;"></ng-container>.
										{{totals.toPay.productList | number:'1.0-4'}}</td>
									<td></td>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="card mb-3">
		<div class="card-header d-flex justify-content-between align-items-center">
			<h3>3. 
				{{options.selected =='quotation'? 'Terminar cotización': ""}} 
				{{options.selected =='saleOrder'? 'Terminar Pedido': ""}} 
				{{options.selected !='quotation' && options.selected !='saleOrder'? 'Método de pago': ""}} 
			</h3>
		</div>
		<div class="card-body">
			<ng-container *ngIf="options.selected!='quotation' && options.selected!='saleOrder'">
				<p>Para confirmar el método de pago basta con rellenar todos los campos que se presentan. Por
					defecto se agregó el <b>monto total de los productos.</b> Al momento de modificar el efectivo, ya no
					sé
					agregará automaticamente el monto de productos que se añadan posteriormente.
				</p>
				<div class="row" style="margin-right: 0; margin-left: 0;">
					<div class="col-sm-4 methods-pay methods-toggle">
						<div class="method-div" (click)="payment.selected='cash'"
							[class.method-selected]="payment.selected == 'cash'"
							[class.method-used]="payment.methods.cash.validated">
							<span class="title-container">
								<!-- <ng-container *ngIf="method.amount!=0 && method.amount!=null">
									<span *ngIf="method.validated" data-tooltip="Metodo seleccionado correctamente"
										data-tooltip-position="top">
										<i class="bx bxs-check-circle"></i>
									</span>
									<span *ngIf="!method.validated"
										data-tooltip="Faltan campos para poder tomar en cuenta este método de pago"
										data-tooltip-position="top">
										<i style="color: red;" class="bx bx-health"></i>
									</span>

								</ng-container> -->
								<i class="{{payment.methods.cash.class}}"></i>
								<span class="method-title">{{payment.methods.cash.title}}</span>
							</span>
							<span><ng-container *ngTemplateOutlet="currency;"></ng-container>
								<span>{{payment.methods.cash.validated?
									payment.methods.cash.amount:'0.00'}}</span></span>
						</div>
						<div class="method-div" (click)="payment.selected='credit'"
							[class.method-selected]="payment.selected == 'credit'"
							[class.method-used]="payment.methods.credit.validated"
							*ngIf="options.selected!='advancePayment'"
							>
							<span class="title-container">
								<!-- <ng-container *ngIf="method.amount!=0 && method.amount!=null">
									<span *ngIf="method.validated" data-tooltip="Metodo seleccionado correctamente"
										data-tooltip-position="top">
										<i class="bx bxs-check-circle"></i>
									</span>
									<span *ngIf="!method.validated"
										data-tooltip="Faltan campos para poder tomar en cuenta este método de pago"
										data-tooltip-position="top">
										<i style="color: red;" class="bx bx-health"></i>
									</span>

								</ng-container> -->
								<i class="{{payment.methods.credit.class}}"></i>
								<span class="method-title">{{payment.methods.credit.title}}</span>
							</span>
							<span><ng-container *ngTemplateOutlet="currency;"></ng-container>
								<span>{{payment.methods.credit.validated ?
									payment.methods.credit.amount:'0.00'}}</span></span>
						</div>
						<div class="method-div" (click)="payment.selected='check'"
							[class.method-selected]="payment.selected == 'check'"
							[class.method-used]="payment.methods.check.validated">
							<span class="title-container">
								<!-- <ng-container *ngIf="method.amount!=0 && method.amount!=null">
									<span *ngIf="method.validated" data-tooltip="Metodo seleccionado correctamente"
										data-tooltip-position="top">
										<i class="bx bxs-check-circle"></i>
									</span>
									<span *ngIf="!method.validated"
										data-tooltip="Faltan campos para poder tomar en cuenta este método de pago"
										data-tooltip-position="top">
										<i style="color: red;" class="bx bx-health"></i>
									</span>

								</ng-container> -->
								<i class="{{payment.methods.check.class}}"></i>
								<span class="method-title">{{payment.methods.check.title}}</span>
							</span>
							<span><ng-container *ngTemplateOutlet="currency;"></ng-container>
								<span>{{payment.methods.check.validated?
									payment.methods.check.amount:'0.00'}}</span></span>
						</div>
						<div class="method-div" (click)="payment.selected='transfer'"
							[class.method-selected]="payment.selected == 'transfer'"
							[class.method-used]="payment.methods.transfer.validated">
							<span class="title-container">
								<!-- <ng-container *ngIf="method.amount!=0 && method.amount!=null">
									<span *ngIf="method.validated" data-tooltip="Metodo seleccionado correctamente"
										data-tooltip-position="top">
										<i class="bx bxs-check-circle"></i>
									</span>
									<span *ngIf="!method.validated"
										data-tooltip="Faltan campos para poder tomar en cuenta este método de pago"
										data-tooltip-position="top">
										<i style="color: red;" class="bx bx-health"></i>
									</span>

								</ng-container> -->
								<i class="{{payment.methods.transfer.class}}"></i>
								<span class="method-title">{{payment.methods.transfer.title}}</span>
							</span>
							<span><ng-container *ngTemplateOutlet="currency;"></ng-container>
								<span>{{payment.methods.transfer.validated?
									payment.methods.transfer.amount:'0.00'}}</span></span>
						</div>
						<div class="method-div" (click)="payment.selected='card'"
							[class.method-selected]="payment.selected == 'card'"
							[class.method-used]="payment.methods.card.validated"
							*ngIf="options.selected!='advancePayment'"
							>
							<span class="title-container">
								<!-- <ng-container *ngIf="method.amount!=0 && method.amount!=null">
									<span *ngIf="method.validated" data-tooltip="Metodo seleccionado correctamente"
										data-tooltip-position="top">
										<i class="bx bxs-check-circle"></i>
									</span>
									<span *ngIf="!method.validated"
										data-tooltip="Faltan campos para poder tomar en cuenta este método de pago"
										data-tooltip-position="top">
										<i style="color: red;" class="bx bx-health"></i>
									</span>

								</ng-container> -->
								<i class="{{payment.methods.card.class}}"></i>
								<span class="method-title">{{payment.methods.card.title}}</span>
							</span>
							<span><ng-container *ngTemplateOutlet="currency;"></ng-container>
								<span>{{payment.methods.card.validated?
									payment.methods.card.amount:'0.00'}}</span></span>
						</div>
						<div class="method-div" (click)="payment.selected='pointsRedemption'"
							[class.method-selected]="payment.selected == 'pointsRedemption'"
							[class.method-used]="payment.methods.pointsRedemption.validated" *ngIf="isAffiliate && options.selected!='advancePayment'">
							<span class="title-container">
								<i class="{{payment.methods.pointsRedemption.class}}"></i>
								<span class="method-title">{{payment.methods.pointsRedemption.title}}</span>
							</span>
							<span>
								<span>{{payment.methods.pointsRedemption.validated ?
									payment.methods.pointsRedemption.amount:'0.00'}}</span></span>
						</div>
						<div
							class="method-div"
							(click)="payment.selected='advance'"
							[class.method-selected]="payment.selected == 'advance'"
							[class.method-used]="payment.methods.advance.validated"
							*ngIf="options.selected!='advancePayment'">

							<span class="title-container">

								<i class="{{payment.methods.advance.class}}"></i>

								<span class="method-title">
									{{payment.methods.advance.title}}
								</span>

							</span>

							<span>
								<ng-container *ngTemplateOutlet="currency;"></ng-container>

								<span>
									{{
										payment.methods.advance.validated
											? payment.methods.advance.amount
											: '0.00'
									}}
								</span>
							</span>

						</div>
					</div>
					<div class="col-sm-8 methods methods-toggle pb-4">
						<div class="alert alert-warning" [class.shake-horizontal]="alertMessage!=''"
							style="margin-top: 1em;"><i class="bx bxs-error"></i>{{alertMessage}}</div>
						<span id="span-rest">Monto restante <ng-container *ngTemplateOutlet="currency;"></ng-container>.
							<span id="mount-rest">{{amountRest}}</span>
						</span>
						<div class="method" [class.show-method]="payment.selected=='check'">
							<h3>Pago con Cheque</h3>
							<div class="row">
								<div class="col-sm form-group">
									<label for="mount-check" class="form-label">Monto</label>
									<div class="input-group">
										<label for="mount-check" class="input-group-text"><i
												[class]="(dollar)?'bx-dollar':'q'" class="currency bx"></i></label>
										<input type="number" class="form-control" id="mount-check" placeholder="0.000"
											min="0" [(ngModel)]="payment.methods.check.amount"
											[disabled]="(ordersSelected.length+productsList.length)==0"
											(ngModelChange)="payWithCheck()">
									</div>
								</div>
								<div class="col-sm form-group">
									<label for="bank-check" class="form-label">Banco Emisor</label>
									<select class="form-select" [(ngModel)]="payment.methods.check.bank"
										name="bank-check" id="bank-check" (change)="payWithCheck()">
										<option value="-1" label="Seleccione un banco...">Seleccione un banco...
										</option>
										<option *ngFor="let bank of banks" value="{{bank.id}}" label="{{bank.name}}">
										</option>
									</select>
								</div>
								<div class="col-sm form-group">
									<label for="date-check" class="form-label">Fecha</label>
									<input type="date" name="date-check" [(ngModel)]="payment.methods.check.date"
										placeholder="Ingresa una fecha" (input)="payWithCheck()" id="date-check"
										class="form-control">
								</div>
							</div>
							<div class="row">
								<div class="col-sm form-group">
									<label for="no-check" class="form-label">Número de Cheque</label>
									<input type="number" name="no-check" id="no-check" class="form-control"
										[(ngModel)]="payment.methods.check.number"
										placeholder="Ingrese el número de cheque" (input)="payWithCheck()">
								</div>
								<div class="col-sm form-group">
									<label for="no-account-check" class="form-label">Número de Cuenta</label>
									<input type="text" name="no-account-check" id="no-account-check"
										class="form-control" [(ngModel)]="payment.methods.check.name"
										placeholder="Ingrese el número de cuenta" (input)="payWithCheck()">
								</div>
								<div class="col-sm form-group"></div>
							</div>
						</div>
						<div class="method" [class.show-method]="payment.selected=='credit'">
							<h3>Pago con Crédito</h3>
							<div class="row">
								<div class="col-sm form-group">
									<label for="mount-credit" class="form-label">Monto</label>
									<div class="input-group">
										<label for="mount-credit" class="input-group-text"><i
												[class]="(dollar)?'bx-dollar':'q'" class="currency bx"></i></label>
										<input type="number" class="form-control" id="mount-credit" name="mount-credit"
											placeholder="0.0000" min="0" [(ngModel)]="payment.methods.credit.amount"
											[disabled]="(ordersSelected.length+productsList.length)==0"
											(input)="changeCashOrCredit($event,'credit')">
									</div>
								</div>
							</div>
						</div>
						<div class="method" [class.show-method]="payment.selected=='card'">
							<h3>Pago con Tarjeta de Crédito/Debito</h3>
							<div class="row">
								<div class="col-sm form-group">
									<label for="mount-card" class="form-label">Monto</label>
									<div class="input-group">
										<label for="mount-card" class="input-group-text"><i
												[class]="(dollar)?'bx-dollar':'q'" class="currency bx"></i></label>
										<input type="number" class="form-control" id="mount-card" name="mount-card"
											placeholder="0.0000" [(ngModel)]="payment.methods.card.amount"
											[disabled]="(ordersSelected.length+productsList.length)==0" min="0"
											(input)="payWithCard()">
									</div>
								</div>
								<div class="col-sm form-group">
									<label for="type-card" class="form-label">Tipo de tarjeta</label>
									<select class="form-select" [(ngModel)]="payment.methods.card.bank"
										(change)="payWithCard()" name="type-card" id="type-card">
										<option value="-1">Elige...</option>
										<option *ngFor="let card of cardTypes" value="{{card.id}}">{{card.name}}
										</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="col-sm form-group">
									<label for="referency-card" class="form-label">Referencia</label>
									<input type="text" [(ngModel)]="payment.methods.card.reference" class="form-control"
										id="referency-card" name="referency-card"
										placeholder="Ingrese código de referencia" (input)="payWithCard()">
								</div>
								<div class="col-sm form-group">
									<label for="authorization-card" class="form-label">Autorizacion</label>
									<input type="text" [(ngModel)]="payment.methods.card.authorization"
										class="form-control" id="authorization-card" name="authorization-card"
										placeholder="Ingrese código de autorización" (input)="payWithCard()">
								</div>
							</div>
						</div>
						<div class="method" [class.show-method]="payment.selected=='transfer'">
							<h3>Pago con Transferencia Bancaria</h3>
							<div class="row">
								<div class="col-sm form-group">
									<label for="mount-transfer" class="form-label">Monto</label>
									<div class="input-group">
										<label for="mount-transfer" class="input-group-text"><i
												[class]="(dollar)?'bx-dollar':'q'" class="currency bx"></i></label>
										<input type="number" class="form-control" id="mount-transfer"
											name="mount-transfer" placeholder="0.0000"
											[(ngModel)]="payment.methods.transfer.amount"
											[disabled]="(ordersSelected.length+productsList.length)==0" min="0"
											(input)="payWithTransfer()">
									</div>
								</div>
								<div class="col-sm form-group">
									<label for="account-transfer" class="form-label">Cuenta Bancaria</label>
									<select class="form-select" [(ngModel)]="payment.methods.transfer.bank"
										name="account-transfer" id="account-transfer" (change)="payWithTransfer()">
										<option value="-1" selected>Seleccione una cuenta...</option>
										<option value="{{account.id}}" *ngFor="let account of bankAccounts">
											{{account.accountNumber}} - {{account.alias}}</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="col-sm form-group">
									<label for="no-transfer" class="form-label">Número de transferencia</label>
									<input type="text" class="form-control" id="no-transfer" name="no-transfer"
										[(ngModel)]="payment.methods.transfer.reference"
										placeholder="Ingrese código de referencia" (input)="payWithTransfer()">
								</div>
								<div class="col-sm form-group">
									<label for="advance-transfer" class="form-label">Cantidad de anticipo</label>
									<input type="number" class="form-control" id="advance-transfer"
										name="advance-transfer" placeholder="0.0000" (input)="payWithTransfer()"
										[(ngModel)]="payment.methods.transfer.advance">
								</div>
							</div>
						</div>
						<div class="method" [class.show-method]="payment.selected=='cash'">
							<h3>Pago con Efectivo</h3>
							<div class="row">
								<div class="col-sm form-group">
									<label for="mount-cash" class="form-label">Monto</label>
									<div class="input-group">
										<label for="mount-cash" class="input-group-text"><i
												[class]="(dollar)?'bx-dollar':'q'" class="currency bx"></i></label>
										<input type="number" class="form-control" id="mount-cash" name="mount-cash"
											placeholder="0.0000" min="0" (input)="changeCashOrCredit($event,'cash')"
											[(ngModel)]="payment.methods.cash.amount"
											[disabled]="(ordersSelected.length+productsList.length)==0">
									</div>
								</div>
								<div class="col-sm form-group">
									<label for="mount-cash" class="form-label">Caja</label>
									<!-- <input type="text" class="form-control" [(ngModel)]="payment.methods.cash.cashier"
										id="mount-cash" name="mount-cash" placeholder="Ingrese una caja..."
										list="cashesList"> -->
									<div class="input-group input-group-sm"
										style="background: white !important; border-radius: var(--bs-border-radius);">
										<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.cashier"
											[placeholder]="'Ingresa o selecciona una caja'"
											[filterElements]="filterCashiers" [typeElements]="'cashier'"
											(changeMethod)="verifiedInput($event.event,'cashier')"
											(inputMethod)="handleInput($event.event,'cashier')"
											(getTitle)="$event.filterElement.title = $event.filterElement.name"
											(changeStatus)="changeStatusInput($event.filterElement,$event.filterElement.name,1,'cashier')"></app-input-autocomplete>
										<!-- <div class="autocomplete" id="cashier-select"
											style="background: white !important; border-radius: var(--bs-border-radius);">
											<input type="text"
												style="border-radius: var(--bs-border-radius) !important;"
												[class.required]="!inputs.cashier.verified"
												class="form-control input-suggestions" name="cashier" id="cashier"
												[(ngModel)]="inputs.cashier.value"
												placeholder="Ingresa o selecciona una caja"
												(input)="handleInput($event,'cashier')" (click)="focusCashier = true"
												(change)="verifiedInput($event,'cashier')" autocomplete="off">
											<div class="suggestions" id="suggestionsCashier" *ngIf="focusCashier">
												<ng-container *ngFor="let filter of filterCashiers">
													<div class="suggestions-item"
														(click)="changeStatusInput(filter, filter.name, 1, 'cashier')">
														{{filter.name}}</div>
												</ng-container>
											</div>
											<span class="input-status">
												<i data-bs-toggle="tooltip" id="status-cashier" data-bs-placement="top"
													data-bs-custom-class="custom-tooltip"
													[attr.data-bs-title]="inputs.cashier.message"
													[attr.data-original-title]="inputs.cashier.message"
													class="fa {{inputs.cashier.class}}"></i>
											</span>
										</div> -->
									</div>
								</div>
							</div>
						</div>

						<div class="method" [class.show-method]="payment.selected=='pointsRedemption'" *ngIf="isAffiliate">
							<h3>Cambio de Puntos</h3>
							<!-- <div class="row">
								<div class="col-sm form-group">
									<label for="mount-pointsRedemption" class="form-label">Puntos (Max. {{affiliatePoints < totals.toPay.sum ? affiliatePoints : totals.toPay.sum}})</label>
									<div class="input-group">
										<label for="mount-pointsRedemption" class="input-group-text"><i
												[class]="(dollar)?'bx-dollar':'q'" class="currency bx"></i></label>
										<input type="number" class="form-control" id="mount-pointsRedemption" name="mount-pointsRedemption"
											placeholder="0.0000" min="0" [(ngModel)]="payment.methods.pointsRedemption.amount"
											[disabled]="(ordersSelected.length+productsList.length)==0 || affiliatePoints==0"
											[max]="affiliatePoints < totals.toPay.sum ? affiliatePoints : totals.toPay.sum"
											(input)="changeCashOrCredit($event,'pointsRedemption')">
									</div>
								</div>
							</div> -->
						</div>

						<div
							class="method"
							[class.show-method]="payment.selected=='advance'">

							<h3>Pago con Anticipo</h3>

							<div class="row">

								<!-- ANTICIPO -->
								<div class="col-sm-7 form-group">

									<label
										for="advance-client"
										class="form-label">

										Anticipo del cliente

									</label>

									<select
										id="advance-client"
										name="advance-client"
										class="form-select"
										[(ngModel)]="payment.methods.advance.advanceId"
										[disabled]="
											loadingAdvancesClient ||
											!inputs.client?.data?.id
										"
										(ngModelChange)="selectAdvanceClient($event)">

										<option [ngValue]="null">
											Seleccione un anticipo...
										</option>

										<option
											*ngFor="let advance of advancesClient"
											[ngValue]="advance.docId ?? advance.id">

											{{ advance.amount | currency:(advance.currency == 1 ? '$' : 'Q') }}

											<!-- {{ advance.docNumber || ('#' + (advance.docId ?? advance.id)) }} -->
											-
											{{ advance.date | date:'dd/MM/yyyy' }}
											-
											{{ advance.rootLocation || '' }}
										</option>

									</select>

									<small
										class="text-muted"
										*ngIf="loadingAdvancesClient">

										Cargando anticipos...

									</small>

									<small
										class="text-muted"
										*ngIf="
											!loadingAdvancesClient &&
											inputs.client?.data?.id &&
											advancesClient.length === 0
										">

										Este cliente no tiene anticipos disponibles.

									</small>

								</div>


								<!-- MONTO -->
								<div class="col-sm-5 form-group">

									<label
										for="mount-advance"
										class="form-label">

										Monto

									</label>

									<div class="input-group">

										<label
											for="mount-advance"
											class="input-group-text">

											<i
												[class]="dollar ? 'bx-dollar' : 'q'"
												class="currency bx">
											</i>

										</label>

										<input
											type="number"
											id="mount-advance"
											name="mount-advance"
											class="form-control"
											placeholder="0.0000"
											min="0"
											[(ngModel)]="payment.methods.advance.amount"
											[disabled]="
												!payment.methods.advance.advance ||
												(ordersSelected.length + productsList.length) == 0
											"
											(ngModelChange)="payWithAdvance()">

									</div>

								</div>

							</div>


							<!-- INFORMACIÓN ANTICIPO SELECCIONADO -->
							<div
								class="row mt-3"
								*ngIf="payment.methods.advance.advance as advance">

								<div class="col-12">

									<div class="alert alert-info mb-0">

										<div>
											<strong>Anticipo disponible:</strong>

											{{
												advance.amount
													| currency:(advance.currency == 1 ? '$' : 'Q')
											}}
										</div>

										<!-- <div>
											<strong>No. Documento:</strong>
											{{ advance.docNumber || advance.docId || advance.id }}
										</div> -->

										<div *ngIf="advance.date">
											<strong>Fecha:</strong>
											{{ advance.date | date:'dd/MM/yyyy' }}
										</div>

										<div *ngIf="advance.rootLocation">
											<strong>Origen:</strong>
											{{ advance.rootLocation }}
										</div>


									</div>

								</div>

							</div>

						</div>
					</div>
				</div>
				<br>
			</ng-container>
			<div class="row" *ngIf="!isAffiliate && options.selected!='saleOrder' && options.selected!='advancePayment'">
				<span class="text-info">
					<i class="bx bxs-error-circle"></i> Dado que el cliente ingresado no es afiliado
				</span>
				<div class="col-sm input-group input-group-sm">
					<label for="affiliate-input" class="input-group-text">Nit/DPI/Codigo Afiliado</label>
					<app-input-autocomplete [allBorderRadius]="false" [inputs]="inputs.affiliate"
						[placeholder]="'Ingresa un afiliado'" [filterElements]="filterAffiliates"
						[typeElements]="'affiliate'" (changeMethod)="verifiedInput($event.event,'affiliate')"
						(inputMethod)="handleInput($event.event,'affiliate')"
						(getTitle)="$event.filterElement.title = $event.filterElement.name"
						(changeStatus)="changeStatusInput($event.filterElement,$event.filterElement.name,1,'affiliate')"></app-input-autocomplete>
				</div>
			</div>
			<div class="totals-container">
				<div class="total-div">
					<div class="total-title">
						<span>Total de</span>
						<b *ngIf="options.selected=='quotation'"> {{'Cotización'}}</b>
						<b *ngIf="options.selected=='saleOrder'"> {{'Pedido'}}</b>
						<b *ngIf="options.selected!='quotation' && options.selected!='saleOrder'"> {{'Factura'}}</b>
					</div>
					<div class="total-value">
						<span id="totalInvoice" class="font-weight-bold"><ng-container
								*ngTemplateOutlet="currency;"></ng-container> {{totals.toPay.sum |
							number:'1.0-4'}}</span>
					</div>
				</div>
				<div class="total-div" [hidden]="options.selected=='quotation' || options.selected=='saleOrder' || options.selected=='advancePayment'">
					<div class="total-title">
						<span>Total de</span><b class="text-success">Pago</b>
					</div>
					<div class="total-value">
						<span id="totalPaid" class="text-success font-weight-bold"><ng-container
								*ngTemplateOutlet="currency;"></ng-container> {{ totals.paid | number:'1.0-4'}}</span>
					</div>
				</div>
				<div class="total-div" [hidden]="options.selected!='advancePayment'">
					<div class="total-title">
						<span>Total de</span><b class="text-success">Anticipo</b>
					</div>
					<div class="total-value">
						<span id="totalPaid" class="text-success font-weight-bold"><ng-container
								*ngTemplateOutlet="currency;"></ng-container> {{ totals.paid | number:'1.0-4'}}</span>
					</div>
				</div>
				<div class="total-div" [hidden]="options.selected!='saleOrder'">
					<div class="total-title">
						<span>Total de</span><b 
						[class.text-success]="(totals.creditAvailable-totals.toPay.productList) > 0" 
						[class.text-danger]="(totals.creditAvailable-totals.toPay.productList) <= 0">Crédito Disponible</b>
					</div>
					<div class="total-value">
						<span id="totalPaid" class="font-weight-bold" 
						[class.text-success]="(totals.creditAvailable-totals.toPay.productList) > 0" 
						[class.text-danger]="(totals.creditAvailable-totals.toPay.productList) <= 0"><ng-container
								*ngTemplateOutlet="currency;"></ng-container> {{ (totals.creditAvailable-totals.toPay.productList) | number:'1.0-4'}}</span>
					</div>
				</div>
				<div class="total-div" [hidden]="options.selected=='quotation' || options.selected=='saleOrder' || options.selected=='advancePayment'">
					<div class="total-title">
						<b class="text-info">Cambio</b>
					</div>
					<div class="total-value">
						<span id="change" class="text-info font-weight-bold"><ng-container
								*ngTemplateOutlet="currency;"></ng-container> {{amountChange | number:'1.0-4'}}</span>
					</div>
				</div>
				<div class="d-flex justify-content-center mt-3">
					<button class="btn btn-success fs-2" [appCheckPermission]="[2000,2046]"
						[permissionType]="permissionType.CREATE" (click)="saveInvoice()"
						[disabled]="!isReadyToSave()">
						<div *ngIf="saving" class="save-invoice-text">
							<div class="spinner-border" role="status"></div>
							<span class="loading-status">Guardando</span>
						</div>
						<span *ngIf="!saving" class="save-invoice-text">
							<i class="bx bxs-save"></i> Guardar
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
<app-success-modal *ngIf="success!=''" [message]="success"></app-success-modal>
<ng-template #currency>
	<i [class]="(dollar)?'bx-dollar':'q'" class="currency bx"></i>
</ng-template>
<div class="modal-background" *ngIf="searchingPrice">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog" style="width: 50%;">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Consulta de precios</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="searchingPrice = false;"></i>
					</h1>
				</div>
				<div class="modal-body">
					<app-price-list-modal></app-price-list-modal>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal-create-warehouse (close)="creatingNewWarehouse = false"
	*ngIf="creatingNewWarehouse"></app-modal-create-warehouse>
<app-simple-modal [max]="50" (close)="hideTokenAuthorization()" [title]="'AUTORIZACIÓN'" *ngIf="invoiceTemp">
	<div fields>
		<div class="input-group">
			<label for="token" class="input-group-text">Token <i class="fa fa-asterisk text-danger"></i></label>
			<input type="text" placeholder="Ingresa un token de autorización" id="token" name="token"
				[(ngModel)]="token" class="form-control">
		</div>
	</div>
	<div buttons>
		<app-loading-button [logo]="true" [colorLoading]="'white'" [disabled]="!token" [object]="tokenButton"
			(clicked)="validateToken()"></app-loading-button>
	</div>
</app-simple-modal>
<app-modal-vendor-billing-nit
    *ngIf="showVendorBillingNitModal"
    [vendor]="inputs.client.data"
    (close)="closeVendorBillingNitModal($event)">
</app-modal-vendor-billing-nit>
<app-modal-client-cf
    *ngIf="showClientCfModal"
    (close)="closeClientCfModal($event)">
</app-modal-client-cf>